import { render, staticRenderFns } from "./channel-pricing-form.vue?vue&type=template&id=3c2149b3"
import script from "./channel-pricing-form.vue?vue&type=script&lang=js"
export * from "./channel-pricing-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports